import React from 'react';
import { useTranslation } from 'react-i18next';
import { RiAddLine, RiDeleteBinLine } from 'react-icons/ri';
import { getLocalized } from '../../i18n/getLocalized';

function renderPreviewCell(col, t) {
  switch (col.type) {
    case 'number':
    case 'currency':
      return <input type="number" className="fm-preview-input" placeholder="0" disabled />;
    case 'date':
      return <input type="date" className="fm-preview-input" disabled />;
    case 'select':
      return (
        <select className="fm-preview-select" disabled>
          <option>{t('fieldsManager.tablePreview.selectPlaceholder')}</option>
          {col.options.map((o) => <option key={o.id}>{o.label}</option>)}
        </select>
      );
    case 'checkbox':
      return <input type="checkbox" disabled />;
    case 'textarea':
      return <textarea className="fm-preview-input" rows={1} placeholder="..." disabled />;
    default:
      return <input type="text" className="fm-preview-input" placeholder="..." disabled />;
  }
}

export default function TablePreview({ columns: rawColumns }) {
  const { t, i18n } = useTranslation();
  // Headers and option labels may be multilang maps — resolve before render.
  const columns = (rawColumns || []).map((c) => ({
    ...c,
    header: getLocalized(c.header, i18n.language),
    options: (c.options || []).map((o) => ({ ...o, label: getLocalized(o.label, i18n.language) })),
  }));
  if (!columns.length) {
    return (
      <div className="fm-table-preview fm-table-preview--empty">
        <p>{t('fieldsManager.tablePreview.addColumnsHint')}</p>
      </div>
    );
  }

  return (
    <div className="fm-table-preview">
      <p className="fm-table-preview__label">{t('fieldsManager.tablePreview.livePreview')}</p>
      <div className="fm-table-preview__scroll">
        <table className="fm-preview-table">
          <thead>
            <tr>
              {columns.map((col) => (
                <th key={col.id} className={`fm-preview-th fm-preview-th--${col.width}`}>
                  {col.header || <em>{t('fieldsManager.tablePreview.untitled')}</em>}
                  {col.required && <span className="fm-required-star">*</span>}
                </th>
              ))}
              <th className="fm-preview-th fm-preview-th--actions" />
            </tr>
          </thead>
          <tbody>
            {[0, 1].map((rowIdx) => (
              <tr key={rowIdx}>
                {columns.map((col) => (
                  <td key={col.id} className="fm-preview-td">
                    {renderPreviewCell(col, t)}
                  </td>
                ))}
                <td className="fm-preview-td fm-preview-td--actions">
                  <button className="fm-icon-btn fm-icon-btn--ghost fm-icon-btn--sm" disabled>
                    <RiDeleteBinLine />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
          <tfoot>
            <tr>
              <td colSpan={columns.length + 1}>
                <button className="fm-btn fm-btn--ghost fm-btn--sm" disabled>
                  <RiAddLine /> {t('fieldsManager.tablePreview.addRow')}
                </button>
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  );
}
